<template>
  <section id="about" class="section">
    <div class="gallery">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/01.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/02.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/03.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/04.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/05.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/07.jpeg">
    </div>
    <div class="gallery">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/06.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/08.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/09.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/10.jpeg">
    </div>
    <div class="gallery">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/11.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/12.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/13.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/14.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/15.jpeg">
      <img src="https://ticketera-prod-storage.s3.amazonaws.com/plop/16.jpeg">
    </div>
    <div class="page">
      <iframe style="border-radius:12px" src="https://open.spotify.com/embed/playlist/0chZSO2GhNLUjfTOzcO5aC?utm_source=generator&amp;theme=0" width="100%" height="152" frameborder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"/>
      <h2>Sobre Plop</h2>
      <p>En el año 2025, Fiesta Plop! Cumple 19 años y se ha convertido en una parte importante en la vida de la comunidad LGBTIQ+ Argentina.</p>
      <p>El ambiente es joven y colorido, y la música aún más. Los DJ enloquecen a la multitud con canciones de programas de televisión de los últimos 20 años y la mejor música pop. La alegría que se vive es contagiosa. </p>
      <p>Reconocida por su gran valor artístico, con un Staff conformado por más de 30 artistas (vestuaristas, musicxs, actores, actrices y bailarinxs) reconocidxs en toda latinoamérica.</p>
      <p>Fiesta Plop! se ha constituido como un espacio de libertad, diversidad y desprejuicio que ya es un clásico en la ciudad de Buenos Aires.  Se realiza todos los viernes, con una propuesta única que combina la experiencia de salir a bailar con un espectáculo teatral multimedia. Se disfruta del humor, el baile y la transgresión. En estos años ocupó espacios tales como el Luna Park, Estadio Obras, Estadio Ferro, Estadio GEBA, Teatro de Flores, Teatro Vorterix, Estadio Malvinas Argentinas, Parque de la Costa, Ciudad Cultural Konex, Costa Salguero, Orgulloba y Marcha del Orgullo LGBT.</p>
      <p>Artistas nacionales e internacionales dieron sus shows en Fiesta PLOP! entre ellos, se destacan Pablo Vittar, Anitta, Cazzu, Detox, Sasha Velour, Natalia Oreiro, Miranda!, Bomba Estéreo, Bianca del Rio etc.</p>
      <p>Además, en los últimos años se ha expandido, llevando su propuesta hacia otras ciudades con exitosas ediciones en Córdoba, Rosario, Mar del Plata, Villa Carlos Paz, Neuquén, Tucumán, Mendoza y Montevideo. En el 2022 realizó su primera gira por Europa y Estados Unidos.</p>
      <a href="mailto:fiesta@plop.com.ar" class="bt">Contactar</a>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AboutComponent'
})
</script>
